import React,{useState} from 'react'
import { useFlutterwave } from 'react-flutterwave';
import{paymentConfig} from '../../utils/constants/payments/flutterwaveConfig'
import BlogNav from '../../components/BlogNav'

export default function CauseDetails() {
    var _paymentConfig = paymentConfig;
    const handleFlutterPayment = useFlutterwave(_paymentConfig);
    const [fname, setFName] = useState('')
    const [phone, setPhone] = useState('')
    const [lname, setLName] = useState('')
    const [email, setEmail] = useState('')
    const [amount, setAmount] = useState(0)
    return (
        <div>
        <section className="causes-details-area ptb-200">
            <div className="container">
                <div className="row">
                    <div className="col-lg-8 col-md-12">
                        <div className="causes-details-desc">
                            <div className="causes-details-image">
                                <img src="/assets/img/causes-details/1.jpg" alt="Cause "/>
                            </div>

                            <div className="causes-details-text">
                                <div className="progress pink">
                                    <div className="progress-bar">
                                        <div className="progress-value" style={{width: '50%'}}>50%</div>
                                    </div>
                                </div>
                                <ul>
                                    <li>
                                        <span>Raised:</span> 
                                        $5000.00
                                    </li>
                                    <li className="left-site">
                                        <span>Goal:</span> 
                                        $8000.00
                                    </li>
                                </ul>
                                <h3>Education for Poor Children</h3>
                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nostrum, accusantium cupiditate exercitationem quaerat dolorum architecto fugiat suscipit praesentium iusto? Fuga cupiditate laboriosam fugiat in, maiores a quidem labore autem accusantium! lore</p>
                                <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Officia cupiditate nihil ipsam atque! Autem dolores id ducimus, ipsum magnam at quidem praesentium possimus harum quas, facere explicabo impedit atque doloremque.</p>
                            </div>

                            <div className="causes-details-meta">
								<div className="entry-meta">
									<ul>
										<li>
                                            <span>Posted On:</span> 
                                            <a href="#">September 31, 2020</a>
                                        </li>
									</ul>
								</div>

								<h3>Raise Fund For Healthy Food</h3>

								<p>Quuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quia non numquam eius modi tempora incidunt ut labore et dolore magnam dolor sit amet, consectetur.</p>

								<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in  sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat.</p>
								
								<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in  sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat.</p>
                            </div>
                            
                            <div className="causes-details-payment">
								<div className="payment-method pb-30">
									<h3>Make Donation </h3>
                                </div>

                                <form className="contact-form">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="form-group">
                                                <input type="text" name="name" id="first-name" className="form-control" placeholder="First Name" onChange={e => setFName(e.target.value)}/>
                                            </div>
                                        </div>

                                        <div className="col-lg-12">
                                            <div className="form-group">
                                                <input type="text" name="name" className="form-control" placeholder="Last Name"onChange={e => setLName(e.target.value)}/>
                                            </div>
                                        </div>

                                        <div className="col-lg-12">
                                            <div className="form-group">
                                                <input type="text" name="text" className="form-control" placeholder="Email"onChange={e => setEmail(e.target.value)}/>
                                            </div>
                                        </div>

                                        <div className="col-lg-12">
                                            <div className="form-group">
                                                <input type="text" name="text" className="form-control" placeholder="Phone" onChange={e => setPhone(e.target.value)}/>
                                            </div>
                                        </div>

                                        <div className="col-lg-12">
                                            <div className="form-group">
                                                <input type="text" name="msg_subject" id="msg_subject" className="form-control" placeholder="Ugx 100000.00" onChange={e => setAmount(e.target.value)}/>
                                            </div>
                                        </div>

                                        <div className="col-lg-12">
                                            <div className="causes-details-btn">
                                                <a  className="default-btn" onClick={
                                        () => {
                                            _paymentConfig.amount = amount;
                                            _paymentConfig.customer.email = email;
                                            _paymentConfig.customer.name =  fname + " " +lname;
                                            _paymentConfig.customer.phonenumber = phone;
                                            handleFlutterPayment({
                                                callback: (response) => {
                                                    console.log(response);
                                                },
                                                onClose: () => {

                                                },
                                            });
                                        }
                                    }>
                                                    Donate Now
                                                    <span></span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </form>
							</div>
                        </div>
                    </div>
                    <BlogNav/>

                </div>
               
            </div>
        </section>
        {/* <InstagramFeed/> */}
        </div>
    )
}
